import useClickOutside from "../../../hook/useClickOutside";
import {
    NotificationDropDownNoContentSubTitle,
    NotificationDropDownNoContentTitle,
    NotificationDropDownNoContentWrapper,
    NotificationDropDownTitle,
    NotificationDropDownWrapper,
} from "../desktopNavbar/navbarStyling";

interface NotificationDropDownProps {
    notificationsPopup: boolean;
    closeNotificationDropDown: () => void;
    setNotificationsPopup: React.Dispatch<React.SetStateAction<boolean>>;
}
const NotificationDropDown = ({ notificationsPopup, closeNotificationDropDown, setNotificationsPopup }: NotificationDropDownProps) => {
    const wrapperRef = useClickOutside(
        notificationsPopup,
        () => {
            setNotificationsPopup(false);
        },
        "click"
    );
    return (
        <NotificationDropDownWrapper ref={wrapperRef}>
            <NotificationDropDownTitle>Notifications</NotificationDropDownTitle>
            {/* <NotificationDropDownItem onClick={() => closeNotificationDropDown()}>
                <NotificationDropDownItemImageWrapper></NotificationDropDownItemImageWrapper>
                <NotificationDropDownItemText>Anystay messaged you: “I understand you have issues checking in?” and what do you think?</NotificationDropDownItemText>
                <NotificationDropDownItemTime>1d</NotificationDropDownItemTime>
            </NotificationDropDownItem>
            <NotificationDropDownItem onClick={() => closeNotificationDropDown()}>
                <NotificationDropDownItemImageWrapper></NotificationDropDownItemImageWrapper>
                <NotificationDropDownItemText>Test 00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000 get</NotificationDropDownItemText>
                <NotificationDropDownItemTime>1d</NotificationDropDownItemTime>
            </NotificationDropDownItem>
            <NotificationDropDownItem onClick={() => closeNotificationDropDown()}>
                <NotificationDropDownItemImageWrapper></NotificationDropDownItemImageWrapper>
                <NotificationDropDownItemText>Hello 123</NotificationDropDownItemText>
                <NotificationDropDownItemTime>1d</NotificationDropDownItemTime>
            </NotificationDropDownItem> */}
            <NotificationDropDownNoContentWrapper>
                <NotificationDropDownNoContentTitle>Nothing here yet</NotificationDropDownNoContentTitle>
                <NotificationDropDownNoContentSubTitle>You don't have any notifications yet</NotificationDropDownNoContentSubTitle>
            </NotificationDropDownNoContentWrapper>
        </NotificationDropDownWrapper>
    );
};

export default NotificationDropDown;
